/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { useFormik } from 'formik'
import { useAuth } from '../core/Auth'
import { AUTH } from '../../../../api/apiEndPoints'
import { AuthJSON } from '../../../../api/apiJSON/auth'
import { success } from '../../../../Global/toast'
import { auth } from '../../../../utils/toast'
import Password from '../../../../_supplier/assets/media/auth/password.png'
import ShowPassword from '../../../../_supplier/assets/media/auth/showPassword.png'
import EmailPhoneIcon from '../../../../_supplier/assets/media/svg_supplier/emailphone.svg'
import PasswordIcon from '../../../../_supplier/assets/media/svg_supplier/password.svg'
import APICallService from '../../../../api/apiCallService'
import { Link, useNavigate } from 'react-router-dom'
import BrandLogo from '../../../../_supplier/assets/media/uTrade-logo.png'
import { authCardClassName } from '../AuthLayout'

const loginSchema = Yup.object().shape({
  email: Yup.string().required('Email / Phone is required'),
  // .email('Wrong email format')
  // .min(3, 'Minimum 3 symbols')
  // .max(50, 'Maximum 50 symbols')
  // .required('Email is required'),
  password: Yup.string()
    .min(6, 'Length should be minimum 6')
    .max(15, 'Length should be maximum 15')
    .required('Password is required'),
})
const initialValues = {
  email: '',
  password: '',
}
/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/
export function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const { saveAuth, saveCurrentUser } = useAuth()
  const [showPassword, setShowPassword] = useState(false)

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        if (/^\d+$/.test(values.email)) {
          let apiService = new APICallService(
            AUTH.LOGIN,
            AuthJSON.login({
              phone: values.email,
              phoneCountry: '+255',
              password: values.password,
            })
          )
          let response = await apiService.callAPI()
          if (response) {
            saveAuth(response.token)
            let user = response.user
            saveCurrentUser(user)
            success(auth.login)
          }
          setLoading(false)
        } else {
          let apiService = new APICallService(
            AUTH.LOGIN,
            AuthJSON.login({
              password: values.password,
              email: values.email,
            })
          )
          let response = await apiService.callAPI()
          if (response?.user?.business?.KYC?.everApproved === true) {
            saveAuth(response.token)
            let user = response.user
            saveCurrentUser(user)
            success(auth.login)
            navigate('/dashboard')
          }else if(response?.user?.business?.KYC?.everApproved === false){
            saveAuth(response.token)
            let user = response.user
            saveCurrentUser(user)
            success(auth.login)
            navigate('/profile-management/manage-profile')
          }  
          setLoading(false)
        }
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('The login details are incorrect')
      }
      setSubmitting(false)
      setLoading(false)
    },
  })

  return (
    <form
      className={clsx(authCardClassName, 'form w-100 position-relative')}
      style={{paddingRight: '86px'}}
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <style>{`
        #kt_login_signin_form .login-field-input {
          background: transparent !important;
          border: none;
          outline: none;
          box-shadow: none;
        }
        #kt_login_signin_form .login-field-input:-webkit-autofill,
        #kt_login_signin_form .login-field-input:-webkit-autofill:hover,
        #kt_login_signin_form .login-field-input:-webkit-autofill:focus,
        #kt_login_signin_form .login-field-input:-webkit-autofill:active {
          -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
          box-shadow: 0 0 0 1000px #fff inset !important;
          -webkit-text-fill-color: inherit !important;
          transition: background-color 99999s ease-in-out 0s;
        }
      `}</style>
      <div className='mb-4 sm:mb-6'>
        <img
          src={BrandLogo}
          alt='logo'
          width={150}
          height={50}
          className='mb-3 mx-auto d-block'
          style={{ maxWidth: '70%', height: 'auto' }}
        />
        <h1 className='text-dark text-center fw-700 mb-3 text-[22px] sm:text-[26px] lg:text-[28px]'>
          Welcome Back!
        </h1>
        <p className='text-center fw-normal text-sm sm:text-base'>Login to your account to continue.</p>
      </div>
      <div className='flex flex-col items-center w-full'>
        <div className='fv-row mb-3 w-full flex flex-col items-center'>
          <div
            style={{
              display: 'flex',
              width: '416px',
              height: '56px',
              padding: '10px 20px',
              alignItems: 'center',
              gap: '10px',
              borderRadius: '12px',
              border: '1px solid var(--essentials-border, #E6E6E7)',
              background: 'var(--white, #FFF)',
            }}
          >
            <img src={EmailPhoneIcon} alt='' width={24} height={24} style={{ flexShrink: 0 }} />
            <input
              placeholder='Email or mobile phone number'
              {...formik.getFieldProps('email')}
              name='email'
              value={formik.values.email.trimStart()}
              onChange={(e) => {
                formik.handleChange(e)
              }}
              className='login-field-input'
              style={{ flex: 1, minWidth: 0, fontSize: '16px', background: 'transparent' }}
              type='text'
              autoComplete='off'
            />
          </div>
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container' style={{ width: '416px', textAlign: 'start' }}>
              <span role='alert' className='text-danger fs-14 fw-500'>
                {formik.errors.email}
              </span>
            </div>
          )}
        </div>
        <div className='fv-row mb-6 w-full flex flex-col items-center'>
          <div
            style={{
              display: 'flex',
              width: '416px',
              height: '56px',
              padding: '10px 20px',
              alignItems: 'center',
              gap: '10px',
              borderRadius: '12px',
              border: '1px solid var(--essentials-border, #E6E6E7)',
              background: 'var(--white, #FFF)',
            }}
          >
            <img src={PasswordIcon} alt='' width={24} height={24} style={{ flexShrink: 0 }} />
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder='Password'
              autoComplete='off'
              {...formik.getFieldProps('password')}
              value={formik.values.password.trimStart()}
              onChange={(e) => {
                formik.handleChange(e)
              }}
              className='login-field-input'
              style={{ flex: 1, minWidth: 0, fontSize: '16px', background: 'transparent' }}
            />
            {showPassword ? (
              <img
                height={15}
                width={25}
                src={ShowPassword}
                onClick={() => {
                  setShowPassword(!showPassword)
                }}
                alt=''
                style={{ cursor: 'pointer', flexShrink: 0 }}
              />
            ) : (
              <img
                height={15}
                width={25}
                src={Password}
                onClick={() => {
                  formik.touched.password ? setShowPassword(!showPassword) : setShowPassword(false)
                }}
                alt=''

                style={{ cursor: 'pointer', flexShrink: 0 }}
              />
            )}
          </div>
          {formik.touched.password && formik.errors.password && (
            <div className='fv-plugins-message-container' style={{ width: '416px', textAlign: 'start' }}>
              <span role='alert' className='text-danger fs-14 fw-500'>
                {formik.errors.password}
              </span>
            </div>
          )}
        </div>
        <div className='w-full flex justify-center mt-5'>
          <div style={{ width: '416px', textAlign: 'right' }}>
            <Link to='/auth/forgot-password' className='link-dark fs-16 fw-bold'>
              Forgot your password?
            </Link>
          </div>
        </div>
        <div className='w-full flex justify-center mt-4'>
          <button
            type='submit'
            id='kt_sign_in_submit'
            className={clsx('form-control form-control-custom text-center border-0')}
            style={{
              display: 'flex',
              width: '416px',
              height: '56px',
              padding: '10px 20px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              background: '#1B74E4',
              borderRadius: '12px',
              fontSize: '16px',
              fontWeight: '600',
              color: '#fff',
              opacity: formik.isSubmitting || !formik.isValid ? 0.5 : 1,
              cursor: formik.isSubmitting || !formik.isValid ? 'not-allowed' : 'pointer',
            }}
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span className='indicator-label fs-16 fw-bolder'>Login</span>}
            {loading && (
              <span className='indicator-progress indicator-label fs-16 fw-600'>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
      <div className='w-full text-center mb-6 sm:mb-10 lg:mb-20 mt-4 sm:mt-5'>
        <Link
          to='/auth/registration'
          className='text-center text-sm sm:text-[16px] font-bold text-[#1B74E4] underline decoration-[1.2px] underline-offset-[2.88px]'
          style={{
            fontFeatureSettings: "'calt' off",
            textDecoration: 'underline',
            textDecorationThickness: '1.2px',
            textUnderlineOffset: '2.88px',
            textUnderlinePosition: 'from-font',
            textDecorationSkipInk: 'none',
          }}
        >
          New to UTrade? Create New Account
        </Link>
      </div>
    </form>
  )
}
